import { Asset } from "../../../models/assets.model.ts";
import { Comment } from "../../../models/comment.model.ts";
import { CommentSerializer } from "../../../models/serializers/CommentSerializer.ts";
import { httpRequest } from "../../http";

export class CommandPatchComment {
    async run(todoId:number, organizationId:number, commentId:number, comment: string, files:Asset[]) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/todos/${todoId}/comments/${commentId}/`;
        const formData = new FormData();
        formData.append("data", JSON.stringify({
            organization: {
                id: organizationId,
            },
            body: comment,
        }));
        if(files && files.length > 0) {
            files.forEach((asset) => {
                if(asset.file) {
                    formData.append("files", asset.file as File);
                }
            });
        }
        try {
            const response = await httpRequest<any>(url, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                method: "PUT",
                body: formData
            });
            return this.deserialize(response.comments);
            
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    deserialize(data: any) : Comment []{
        const serializer = new CommentSerializer();
        return serializer.deserializeList(data);
    }
}

